import { Currency } from '@fiverr-private/currencies_plugin/dist/interface';

export type CurrencyObject = Currency & { symbol: string };

export const getDefaultCurrencyObject = (): CurrencyObject => ({
    forceRound: true,
    forceRoundFromAmount: 1000,
    name: 'USD',
    rate: 1,
    symbol: '$',
    // eslint-disable-next-line no-template-curly-in-string
    template: '${{amount}}',
});
